export default __webpack_public_path__ + "media/images/ad_landing_page/Johnson-f951effbba4d671ca24321e439facc8c.png";